import ajax from '../ajax'
//用户列表数据获取
export function getUserListApi(params) {
    return ajax({
        method:'get',
        url: 'v2/user/index',
        params
    })
}
// 列表修改
export function editListApi(data) {
    return ajax({
        method:'post',
        url: 'v2/user/edit',
        data
    })
}

//后台用户
export function AdminListApi(data) {
    return ajax({
        method:'post',
        url: 'v2/admin/admin',
        data
    })
}

//v2/user/refer
export function ReferListApi(data) {
    return ajax({
        method:'post',
        url: 'v2/user/refer',
        data
    })
}
//v2/admin/addone  添加后台用户
export function AddoneApi(data) {
    return ajax({
        method:'post',
        url: 'v2/admin/addone',
        data
    })
}

export function EditApi(data) {
    return ajax({
        method:'post',
        url: 'v2/admin/edit',
        data
    })
}

//模型作者
export function ModelApi(data) {
    return ajax({
        method:'post',
        url: 'v2/user/model',
        data
    })
}




// WEBPACK FOOTER //
// ./src/apis/user/index.js